export default __webpack_public_path__ + "static/media/glitter_bomb_fireworks.cc3ce0c1.gif";